import type { Color } from "../../../../aysa_api/features/ui/v1/color.types";
import { Reader, Writer } from "protobufjs/minimal";

export const createBaseColor = (): Color => {
  return {
    hex: "",
  };
};

export const decodeColor = (reader: Reader, length: number): Color => {
  const end = reader.pos + length;
  const message = createBaseColor();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.hex = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeColor = (writer: Writer, message: Color): Writer => {
  writer.uint32(10).string(message.hex);

  return writer;
};
